import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
    ActivatedRoute,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class LoginRedirectService {
    url: string = '';

    constructor(
        private activeRoute: ActivatedRoute,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    remember(state: RouterStateSnapshot) {
        if (isPlatformBrowser(this.platformId)) {
            const url = this.router.parseUrl('/sign-in');
            url.queryParams = {
                afterLogin: state.url,
            };
            return url;
        }
        // show a blank screen when going to a website that is protected by a login
        return this.router.parseUrl('/not-authenticated');
    }

    retrieve(): Observable<UrlTree> {
        return this.activeRoute.queryParams.pipe(
            take(1),
            map(params =>
                this.router.parseUrl(params.afterLogin || '/dashboard')
            )
        );
    }
}
